import { Transaction } from "../../features/transaction/models/transaction.model";

export function getFullName(transaction: Transaction): string {
  const { firstName = '', middleName = '', lastName = '' } = transaction;
  return [firstName, middleName, lastName].filter(Boolean).join(' ');
}
